import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKhanacademyComponent } from './simple-icons-khanacademy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKhanacademyComponent ],
    exports:      [ SimpleIconsKhanacademyComponent ],
    bootstrap:    []
})
export class SimpleIconsKhanacademyModule {}
